import sampleSize from "lodash.samplesize";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { db, dbNonveg } from "./db";
import FoodCard from "./FoodCard";
import Toggle from "./Toggle";
import { BsSearch, BsX } from "react-icons/bs";
import Loader from "./Loader";
const Home2 = () => {
  const [vegOnly, setVegOnly] = useState(false);
  const [loader, setLoader] = useState(false);
  const uniqueCuisines = [
    "All",
    "Main Course",
    "Snack",
    "Dessert",
    "Sides",
    "Beverages",
  ];
  const [searchResults, setSearchResults] = useState([]);
  const [cuisine, setCuisine] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = useCallback(
    (e) => {
      setLoader(true);
      setTimeout(() => {
        setLoader(false);

        const terms = e.split(" ");
        let temp = vegOnly ? [...db] : [...dbNonveg, ...db];
        let result = [];
        e !== "" &&
          terms.forEach((term) => {
            result = temp.filter(
              (recipe) =>
                (recipe.category === cuisine || cuisine === "All") &&
                recipe.ingredientList.toLowerCase().includes(term.toLowerCase())
            );
            let temp2 = temp.filter(
              (recipe) =>
                (recipe.category === cuisine || cuisine === "All") &&
                recipe.recipeName.toLowerCase().includes(term.toLowerCase())
            );
            console.log(temp2);
            result = [...result, ...temp2];
          });
        e === "" ? setSearchResults([]) : setSearchResults(result);
      }, 1000);
    },
    [cuisine, vegOnly]
  );

  const randomGenerator = useCallback(() => {
    if (searchTerm !== "") {
      handleSearch(searchTerm);
    } else {
      setLoader(true);
      setTimeout(() => {
        setLoader(false);

        let recipes = vegOnly ? [...db] : [...dbNonveg, ...db];
        const temp = recipes.filter(
          (recipe) => recipe.category === cuisine || cuisine === "All"
        );
        setSearchResults(sampleSize(temp, 4));
      }, 1000);
    }
  }, [cuisine, handleSearch, searchTerm, vegOnly]);

  useEffect(() => {
    handleSearch(searchTerm);
  }, [cuisine, searchTerm, handleSearch, vegOnly, randomGenerator]);
  useEffect(() => {
    randomGenerator();
  }, [cuisine, randomGenerator]);
  return (
    <Container>
      {loader && <Loader />}
      <Head>
        <SearchContainer>
          <BsSearch size={20} color="#f15d53" />
          <SearchInput
            placeholder="Add ingredients you want to use"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <BsX size={20} color="#f15d53" onClick={() => setSearchTerm("")} />
        </SearchContainer>
      </Head>
      <Body>
        <FilterContainer>
          {uniqueCuisines.map((uniqueCuisine, index) => (
            <FilterCapsule
              key={index}
              onClick={() => setCuisine(uniqueCuisine)}
              cuisine={cuisine}
              uniqueCuisine={uniqueCuisine}
            >
              {uniqueCuisine}
            </FilterCapsule>
          ))}
        </FilterContainer>
        <ToggleContainer>
          Veg Only{" "}
          <Toggle size={0.5} vegOnly={vegOnly} setVegOnly={setVegOnly} />
        </ToggleContainer>
        <ResultContainer>
          {searchResults.map((recipe, index) => (
            <FoodCard recipe={recipe} key={index} />
          ))}
        </ResultContainer>
      </Body>
      <Footer>
        <Left />
        <Middle>
          <RandomButton onClick={() => randomGenerator()}>
            Kuchh bhi!
          </RandomButton>
        </Middle>
        <Right />
      </Footer>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  font-size: 14px;
  max-height: 100vh;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
const Head = styled.div`
  width: 100%;
  height: 100px;
  min-height: 100px;
  max-height: 300px;
  background-color: #f15d53;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 24px 12px;
  display: flex;
  justify-content: center;
`;
const SearchContainer = styled.div`
  width: 100%;
  padding: 12px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  max-width: 600px;
`;
const SearchInput = styled.input`
  outline: none;
  border: none;
  padding: 4px;
  width: 100%;
  margin-left: 8px;
`;
const Body = styled.div`
  width: 100%;
  overflow: auto;
`;
const FilterContainer = styled.div`
  /* max-width: 100%; */
  display: flex;
  padding: 20px 10px;
  overflow: auto;
`;
const FilterCapsule = styled.div`
  border-radius: 1000px;
  border: 1px solid #f15d53;
  margin: 0 4px;
  padding: 4px 12px;
  white-space: nowrap;
  cursor: pointer;
  background-color: ${(props) =>
    props.cuisine === props.uniqueCuisine ? "#f15d53" : "#fff"};
  color: ${(props) =>
    props.cuisine === props.uniqueCuisine ? "#fff" : "#333333"};
`;
const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
`;
const ResultContainer = styled.div`
  padding: 16px;
  /* height: auto; */
`;
const Footer = styled.div`
  min-height: 50px;
  height: 50px;
  /* flex-grow:1; */
  margin-top: auto;
  /* position: fixed; */
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: fixed;
  bottom: 0;
  width: 100%;
`;
const RandomButton = styled.button`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: none;
  border: 4px solid #fff;
  background-color: #f15d53;
  position: absolute;
  bottom: 50%;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  :focus {
    background-color: #f15d53;
    outline: none;
  }
`;
const Left = styled.div`
  height: 100%;
  background-color: #f15d53;
  flex-grow: 1;
  /* border-top-right-radius: 8px; */
  border-top-left-radius: 8px;
`;
const Middle = styled.div`
  width: 70px;
  height: 100%;
  background-color: #f15d53;
  display: flex;
  justify-content: center;
  /* border-top-right-radius: 1px; */
  /* border-top-left-radius: 1px; */
`;
const Right = styled.div`
  height: 100%;
  background-color: #f15d53;
  flex-grow: 1;
  border-top-right-radius: 8px;
  /* border-top-left-radius: 8px; */
`;
export default Home2;
